import { createFileRoute, useParams } from '@tanstack/react-router'
import { useQuery } from '@tanstack/react-query'
import { supabase } from '@/integrations/supabase/client'
import { useBookingFlow } from '@/hooks/booking/useBookingFlow'

import { BookingServiceSelection } from '@/components/booking/BookingServiceSelection'
import { BookingVehicleSelection } from '@/components/booking/BookingVehicleSelection'
import { BookingProfessionalSelection } from '@/components/booking/BookingProfessionalSelection'
import { BookingDateSelection } from '@/components/booking/BookingDateSelection'
import { BookingTimeSelection } from '@/components/booking/BookingTimeSelection'
import { BookingCheckout } from '@/components/booking/BookingCheckout'
import { BookingConfirmation } from '@/components/booking/BookingConfirmation'

export const Route = createFileRoute('/agendar/$slug')({
  component: AgendarLavaRapido,
})

function AgendarLavaRapido() {
  const { slug } = useParams({ from: '/agendar/$slug' })

  const companyQuery = useQuery({
    queryKey: ['public-company', slug],
    queryFn: async () => {
      const { data, error } = await supabase
        .rpc('get_company_by_slug', { p_slug: slug })
        .maybeSingle()
      
      if (error) throw error
      return data as { id: string, name: string } | null
    },
  })

  const flow = useBookingFlow(slug, companyQuery.data)

  if (companyQuery.isLoading) {
    return (
      <div className="flex items-center justify-center min-h-screen bg-slate-950 text-slate-100">
        <div className="animate-pulse">Carregando lava-rápido...</div>
      </div>
    )
  }

  if (!companyQuery.data) {
    return (
      <div className="flex flex-col items-center justify-center min-h-screen bg-slate-950 text-slate-100 text-center p-4">
        <h1 className="text-2xl font-bold mb-2">Lava-rápido não encontrado</h1>
        <p className="text-slate-400">Verifique se o link está correto.</p>
      </div>
    )
  }

  return (
    <div className="min-h-screen bg-slate-950 text-slate-100 flex justify-center p-4 sm:p-8">
      <div className="w-full max-w-md flex flex-col pt-8">
        <header className="mb-8 text-center animate-in fade-in slide-in-from-top-4">
          <h1 className="text-2xl font-bold text-slate-100">{companyQuery.data.name}</h1>
          <p className="text-slate-400">Agende sua lavagem</p>
        </header>

        <div className="flex-1">
          {flow.step === 1 && <BookingServiceSelection flow={flow} />}
          {flow.step === 2 && <BookingVehicleSelection flow={flow} />}
          {flow.step === 3 && <BookingProfessionalSelection flow={flow} />}
          {flow.step === 4 && <BookingDateSelection flow={flow} />}
          {flow.step === 5 && <BookingTimeSelection flow={flow} />}
          {flow.step === 6 && !flow.confirmed && <BookingCheckout flow={flow} />}
          {flow.step === 6 && flow.confirmed && <BookingConfirmation flow={flow} />}
        </div>
      </div>
    </div>
  )
}
